import React from 'react';

// White G mark (single color) — designed for colored background buttons
export const GoogleLogo = ({ size = 18 }) => (
  <svg viewBox="0 0 16 16" width={size} height={size} aria-hidden="true">
    <path fill="#fff" d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z" />
  </svg>
);

// Naver N — stylized letterform with diagonal stroke
export const NaverLogo = ({ size = 18 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <path fill="#fff" d="M16.273 12.845 7.376 0H0v24h7.726V11.156L16.624 24H24V0h-7.727z" />
  </svg>
);

// Kakao chat bubble — rounded speech bubble with tail
export const KakaoLogo = ({ size = 18 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <path fill="#3C1E1E" d="M12 3C6.48 3 2 6.48 2 10.8c0 2.78 1.84 5.22 4.6 6.62l-1.14 4.18c-.1.36.3.66.62.46L11 19.5c.33.02.66.04 1 .04 5.52 0 10-3.48 10-7.74S17.52 3 12 3z" />
  </svg>
);
